<!--div class="wrapper wrapper-content">
  <div class="container-fluid p-0" *ngIf="isLoaded()"-->
<div class="row">
  <div class="col-12">
    <div class="titleElement">
      {{'DaciExt.title'| translate}} </div>
  </div>
  <div class="col-12">
    <p-table [value]="dacis" [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>
            {{'DaciExt.personDNICIF'|translate}}
          </th>
          <th>
            {{'DaciExt.login'|translate}}
          </th>
          <th>
            {{'DaciExt.nameAndSurname'|translate}}
          </th>
          <th>
            {{'DaciExt.cargo'|translate}}
          </th>
          <th>
            {{'DaciExt.email'|translate}}
          </th>
          <th>
            {{'DaciExt.creationdate'|translate}}
          </th>
          <th>
            {{'DaciExt.state'|translate}}
          </th>
          <th class="action-column-2"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-daci>
        <tr>
          <td pTooltip="{{ daci.personDNICIF}}">
            <span class="p-column-title">{{'DaciExt.personDNICIF'|translate}}</span>
            {{daci.personDNICIF}}
          </td>
          <td class="text-truncate" pTooltip="{{ daci.login}}">
            <span class="p-column-title">{{'DaciExt.login'|translate}}</span>
            {{daci.login}}
          </td>
          <td class="text-truncate"
            pTooltip="{{ daci.personName || ' ' || daci.personLastName1 || ' ' ||  daci.personLastName2}}">
            <span class="p-column-title">{{'DaciExt.nameAndSurname'|translate}}</span>
            {{ daci.personName + ' ' + daci.personLastName1 + ' ' + (daci.personLastName2 != null ? daci.personLastName2
            : '')}}
          </td>
          <td pTooltip="{{ daci.cargo}}">
            <span class="p-column-title">{{'DaciExt.cargo'|translate}}</span>
            {{daci.cargo}}
          </td>
          <td class="text-truncate" pTooltip="{{ daci.email}}">
            <span class="p-column-title">{{'DaciExt.email'|translate}}</span>
            {{daci.email}}
          </td>
          <td pTooltip="{{daci.creationdate | date: DATEPIPE_DATETIME_FORMAT}}">
            <span class="p-column-title">{{'DaciExt.creationdate'|translate}}</span>
            {{daci.creationdate | date:'dd/MM/yyyy HH:mm:ss'}}
          </td>
          <td pTooltip="{{ daci.descriptionI18}}">
            <span class="p-column-title">{{'DaciExt.state'|translate}}</span>
            <span [ngSwitch]="daci?.state?.state?.identifier?.split('<>')[0]">
              <i class="text-danger fas fa-times" aria-hidden="true" *ngSwitchCase="1"></i>
              <i class="text-success fas fa-check" aria-hidden="true" *ngSwitchCase="2"></i>
              <i class="text-info far fa-clock" aria-hidden="true" *ngSwitchCase="3"></i>
              <i class="text-info far fa-clock" aria-hidden="true" *ngSwitchCase="undefined"></i>
              <span *ngSwitchDefault></span>
            </span>
          </td>

          <td class="action-column-2x text-right  w-50">
            <pmenu-actions [dto]="daci" [lazy]="true" [dtoType]="'DACIEXT'" [items]="getMenuItem(daci)">
            </pmenu-actions>
          </td>

          <!--td class="action-column-2">
            <div class=" btn-group">
              <button class="btn btn-sm btn-secondary t-action-button" (click)="view(daci)"
                title="{{ 'General.view' | translate}}">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm btn-secondary t-action-button" (click)="modify(daci)"
                title="{{ 'General.edit' | translate}}">
                <i class="fas fa-pencil-alt" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm btn-secondary t-action-button" (click)="delete(daci)"
                title="{{'General.delete'|translate}}">
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </td-->

        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="text-center">
          <td colspan="5"><span>{{ 'General.noData' | translate }}</span></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="form-group">
      <button type="button" class="btn btn-primary btn-sm float-right m-t-sm" data-dismiss="modal" (click)="add()">
        <i class="fa-check fas" aria-hidden="true"></i> {{ 'DaciExt.add' | translate }}
      </button>
    </div>
  </div>
</div>